export enum PrivacyOptionsValue {
  PUBLIC = 'Public',
  PRIVATE = 'Private',
}
export enum VisibilityOptionsValue {
  EVERYONE = 'All',
  MEMBER = 'MemberOnly',
}

export enum GroupMemberType {
  OWNER = 'Owner',
  ADMIN = 'Admin',
  MEMBER = 'Member',
  NA = 'NA',
}
